import { RegistrationCategoriesProvider } from './components/registration-categories-provider';
import { RegistrationCategoriesForm } from './components/registration-categories-form';
import { QualificationForm } from './components/qualification-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useCompetitionQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { idParamSchema } from '~/schemas';

export const Page = withPrivateRoute(() => {
  const { id } = useParams(idParamSchema.parse);
  const { data: competition } = useCompetitionQuery(id);

  if (!competition) {
    return false;
  }

  return (
    <RegistrationCategoriesProvider>
      <PageLayout.Heading text={competition.name} />

      <PageLayout.Section>
        <RegistrationCategoriesForm />
      </PageLayout.Section>

      <PageLayout.Section>
        <QualificationForm />
      </PageLayout.Section>
    </RegistrationCategoriesProvider>
  );
});
